module.exports = __webpack_public_path__ + "static/media/tkinter_introduction.c485e466.gif";